import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconBookmarkProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconBookmark: React.FC<IconBookmarkProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Bookmark',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconBookmark;
